  const DownloadAppConstants = {
    filters: [
      {
        key: 'platform',
        label: 'Platform',
        options: [
          { name: 'android', value: 'android' },
          { name: 'ios', value: 'iOS' },
        ],
      },
      {
        key: 'type',
        label: 'Build Type',
        options: [
          { name: 'stable', value: 'stable' },
          { name: 'beta', value: 'beta' },
        ],
      },
    ],
  }

  export default DownloadAppConstants;